import { useEffect, useState } from "react";

import { isTestEnv, resolvePromiseWithDelay } from "@smart/itops-utils-basic";

import { getLocalSmokeballAppContext, observeChange } from "./utils";
import { Staff, UseLocalApiOptions } from "../types";

export const useStaff = ({ observe }: UseLocalApiOptions) => {
  const [loading, setLoading] = useState(true);
  const [currentStaff, setCurrentStaff] = useState<Staff[]>([]);

  const devLocalStaff = [
    {
      id: "e80312df-9351-4685-a88c-24442044c177",
      userId: "1babf7bd-ccd4-433d-8ada-28e2bac5e8d3",
      firstName: "Chi",
      lastName: "Duong",
      enabled: true,
    },
    {
      id: "00a034ec-83b4-4214-9a6c-8d72f9db78fd",
      userId: "59580e2e-9fcc-4c12-ac7b-c5dc3d45076e",
      firstName: "Ben",
      lastName: "Enviah",
      enabled: true,
    },
    {
      id: "ef5c4156-8b98-4dc7-9508-15a848f8ebcb",
      userId: "e85a39af-ed83-4aa6-a33a-3d429f5bbada",
      firstName: "Maddi",
      lastName: "Joyce",
      enabled: true,
    },
    {
      id: "299104d1-54ef-41a4-894c-cffaf9c627a6",
      userId: "b06743db-9b8d-45cd-b197-205610453285",
      firstName: "Joey",
      lastName: "Zheng",
      enabled: true,
    },
    {
      id: "a8543ce4-f52a-48e4-b616-90767c2ac498",
      userId: "da63697b-c490-4e37-ac22-679d68baef7d",
      firstName: "Andres",
      lastName: "Amado",
      enabled: true,
    },
  ] as Staff[];

  const shouldObserve = observe?.includes("staff");
  const localStaff = isTestEnv()
    ? (getLocalSmokeballAppContext()?.staff as Staff[])
    : devLocalStaff;

  useEffect(() => {
    if (shouldObserve) {
      setLoading(true);
      setCurrentStaff(localStaff);
      setLoading(false);

      observeChange("staff", () => setCurrentStaff(localStaff));
    }
  }, [shouldObserve]);

  return {
    all: () => resolvePromiseWithDelay(localStaff),
    current: currentStaff,
    loading,
  };
};
